import {compose} from 'redux';
import withCitiesAndStreets from '../hoc-helpers/withCitiesAndStreets';
import DataTableWithFilters from './DataTableWithFilters';

export default compose(
  withCitiesAndStreets
)(DataTableWithFilters);
